import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    userInfo:null,
    deviationSenconds:null
}

const mutations = {
  setUserInfo(state,userInfo) {
    state.userInfo = userInfo;
  },
  setSenconds(state,deviationSenconds) {
    state.deviationSenconds = deviationSenconds;
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/assets/js/stateStore.js